// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://txvwhcyhgrunhdhplrlo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR4dndoY3loZ3J1bmhkaHBscmxvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3NDk1NTEsImV4cCI6MjA2ODMyNTU1MX0.f4OV_TUnBN08XmxlaTFZU4iPhfdTaHE2EZ0Tqoj7qJs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});